import {RowData} from './RowData';

export type LinkClickOverride = (props: {
  rowData: RowData;
  defaultRedirectRoute: string;
  value: unknown;
}) => void;
